import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef,  MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable, combineLatest, of } from 'rxjs';
import { map, combineAll } from 'rxjs/operators';
import { CompanyUserService } from 'src/app/admin-setting/assing-company-users/company-user.service';
import { UpdateSitesPopup } from 'src/app/admin-setting/assing-company-users/company-users-list/update-sites-popup/update-sites-popup';
import { SystemService } from '../../../../services/system.service';


@Component({
  selector: 'sites-category-popup',
  templateUrl: './sites-category-popup.html',
  styleUrls: ['./sites-category-popup.css',
    '../../../../admin-dashboard/common-popup/common-popup.css']
})
export class SitesCategoryPopup {
  roles = ['admin', 'editor', 'subscriber'];
  selectedOptions = [];

  objectKeys = Object.keys;
  companies = new Observable();
  companies$ = new Observable();

  constructor(public dialogRef: MatDialogRef<UpdateSitesPopup>,
    @Inject(MAT_DIALOG_DATA) public data,
    private systemService: SystemService) {


    console.log(this.selectedOptions)
    // this.companies = this.systemService.getAllCategories$()
    combineLatest([this.systemService.getAllSiteCategories$(this.data['siteId']), this.systemService.getAllCategories$()]).subscribe(data => {
      this.companies = of(data[1].filter((val) => {
        return data[0].indexOf(data[0].find(d => val.dbid == d['categoryId'])) == -1;
      }))

    //  this.companies =  finder.map((cat) => {
    //     let findCat =  data[1].find(origCat => origCat.dbid == cat['categoryId'])
    //     return {...findCat,...cat}
    //   })


      // console.log(this.companies)
    })
  }

  onNgModelChange(category) {
    // site.active = !site.active;
    console.log(category, this.data['siteId'])
    this.systemService.setSiteCategory(this.data['siteId'], category.dbid, {subsidyActive:"true",subsidy : 0})


    // if(site.active)
    //     this.selectedOptions.push(site.siteId)
    // else
    //     this.selectedOptions =this. selectedOptions.filter(e => e !== site.siteId);

  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
